const CHART_RETURN_PATH = /^\/(?:charts|maps?)(?:\/|$)/;
const CHART_FALLBACK = '/charts';

export function chartReturnPath(currentPath) {
  if (!currentPath) return CHART_FALLBACK;
  const pathname = currentPath.split('#')[0].split('?')[0];
  return CHART_RETURN_PATH.test(pathname) ? currentPath : CHART_FALLBACK;
}

export function signInUrl(loginUrl, currentPath) {
  const returnTo = encodeURIComponent(chartReturnPath(currentPath));
  const joiner = loginUrl.indexOf('?') === -1 ? '?' : '&';
  return `${loginUrl}${joiner}redirectUrl=${returnTo}`;
}



// WEBPACK FOOTER //
// ./src/utils/urls/signInUrl.js